import { render, staticRenderFns } from "./MicroBase.vue?vue&type=template&id=723d73a7&scoped=true"
import script from "./MicroBase.vue?vue&type=script&lang=js"
export * from "./MicroBase.vue?vue&type=script&lang=js"
import style0 from "./MicroBase.vue?vue&type=style&index=0&id=723d73a7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723d73a7",
  null
  
)

export default component.exports